import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { Observable } from 'rxjs';
import {
  DeepPartial,
  PaginationOptions
} from '../../../../shared/components/search-header/models/entity-params';
import { IParcelasReceber } from '../../../contas-receber/models/parcelas.model';
import {
  EventoLimiteCredito,
  EventoLimiteCreditoResult,
  ICliente
} from '../../model/cliente.model';

import { ICondicaoPagamento } from '../../../condicao-pagamento/models/condicao.model';

interface cond_pagto_disponiveis {
  cliente: {
    condicao_pagamentos: ICondicaoPagamento[];
  };
  pagination: {
    total: number;
    page: number;
    page_size: number;
  };
}

interface cond_pagto_bloqueadas {
  cliente: {
    condicao_pagamentos: ICondicaoPagamento[];
  };
  pagination: {
    total: number;
    page: number;
    page_size: number;
  };
}

@Injectable()
export class ClienteService extends EntityService<ICliente> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'cliente'
    });
  }

  /**
   * Responsável por enviar um evento de atualização do limite de credito
   * @param cliente_id
   * @param evento
   * @returns
   */
  atualizarLimiteDeCredito(cliente_id: string, evento: EventoLimiteCredito) {
    const url = `${this.baseURL}/${cliente_id}/reg_cliente_limite_credito_evento`;
    return this.http.put<{ evento: EventoLimiteCreditoResult }>(url, evento, {
      headers: this.getHeader()
    });
  }

  /**
   * Pega todas as parcelas em aberto de um cliente
   * @param cliente_id
   * @param include
   * @param pagination
   * @param where
   * @param order_by
   * @returns
   */
  public pegarParcelasAbertas(
    cliente_id: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    where?: DeepPartial<IParcelasReceber>,
    order_by?: string
  ): Observable<any> {
    const url = `${this.baseURL}/${cliente_id}/conta_receber_parcelas`;
    let params = new HttpParams();

    if (include) {
      params = params.append('include', include.join(','));
    }
    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${Object.keys(where)[0]}`, where.status);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<{
      cliente: { conta_receber_parcelas: IParcelasReceber[] };
      pagination: PaginationOptions;
    }>(url, { headers: this.getHeader(), params });
  }

  /**
   * Responsável por pegar todas as condições de pagto disponíveis para um cliente
   * @param cliente_id
   * @param domain_id
   * @param include
   * @param pagination
   * @param order_by
   * @param where
   * @returns
   */
  public condPagtoDisponiveis(
    cliente_id: string,
    domain_id: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    order_by?: string,
    where?: { field: string; value: string }
  ): Observable<cond_pagto_disponiveis> {
    const url = `${this.baseURL}/${cliente_id}/condicao_pagamento_disponiveis`;
    let params = new HttpParams();

    if (domain_id) {
      params = params.append('domain_id', domain_id);
    }

    if (include) {
      params = params.append('include', include.join(','));
    }

    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${where.field}`, where.value);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<cond_pagto_disponiveis>(url, {
      headers: this.getHeader(),
      params
    });
  }
  public condPagtoBloqueadas(
    cliente_id: string,
    domain_id: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    order_by?: string,
    where?: { field: string; value: string }
  ): Observable<cond_pagto_bloqueadas> {
    const url = `${this.baseURL}/${cliente_id}/condicao_pagamento_bloqueadas`;
    let params = new HttpParams();

    if (domain_id) {
      params = params.append('domain_id', domain_id);
    }

    if (include) {
      params = params.append('include', include.join(','));
    }

    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${where.field}`, where.value);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<cond_pagto_bloqueadas>(url, {
      headers: this.getHeader(),
      params
    });
  }
}
